import "./contactus.css"
import {connect} from "react-redux";
import React, {useMemo, useState} from "react";
import {Col, Container, FloatingLabel, Form, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import axiosHandler from "../../services/https";
import MapitalyModal from "../MapitalyModal";

const ContactUs = ({
                       confirmAction,
                       cancelAction,
                       isAuthenticated,
                       user
                   }) => {

    const defaultModal = {
        modalTitle: "",
        modalText: "",
        confirmText: "",
        cancelText: "",
        show: false,
        handleClose: () => {
            updateModal({show: false});
        },
        handleHide: null,
        handleConfirm: null,
        handleCancel: null
    };
    const [modal, setModal] = useState(defaultModal);
    const updateModal = (updates, reset = false) => {
        const placeholder = reset ? defaultModal : modal;
        setModal({...placeholder, ...updates});
    }

    const [validated, setValidated] = useState(false);

    const initialContactUsForm = isAuthenticated && user ?
        {
            name: user.preferred_username,
            lastname: '',
            email: user.email,
            company: '',
            reason: '',
            description: '',
            acceptance: true,
            attachment: null
        }
        :
        {
            name: '',
            lastname: '',
            email: '',
            company: '',
            reason: '',
            description: '',
            acceptance: false,
            attachment: null
        };
    const [contactUsForm, setContactUsForm] = useState(initialContactUsForm);

    useMemo(() => {
        setContactUsForm(isAuthenticated && user ?
            {
                name: user.preferred_username,
                lastname: '',
                email: user.email,
                company: '',
                reason: '',
                description: '',
                acceptance: true,
                attachment: null
            }
            :
            {
                name: '',
                lastname: '',
                email: '',
                company: '',
                reason: '',
                description: '',
                acceptance: false,
                attachment: null
            });
        if (validated) {
            setValidated(false)
        }
    }, [isAuthenticated, user]);
    const resetContactUsForm = () => {
        setContactUsForm(initialContactUsForm);
    }

    const fileToDataUri = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            resolve(event.target.result)
        };
        reader.readAsDataURL(file);
    })

    const handleContactUsFormChange = (e) => {
        if (e.target.type === 'file') {
            const name = e.target.files[0].name;
            const type = e.target.files[0].type;
            const size = e.target.files[0].size;
            fileToDataUri(e.target.files[0])
                .then(dataUri => {
                    setContactUsForm({
                        ...contactUsForm,
                        attachment: {
                            name,
                            type,
                            data: dataUri.split("base64,")[1],
                            size
                        },
                    })
                });
        } else {
            const newContactUsForm = {...contactUsForm, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value};
            setContactUsForm(newContactUsForm);
        }
    }

    const reasonList = [
        {
            label: 'Information request',
            id: 'information-request',
            key: 'reason-0'
        }
    ];

    if (isAuthenticated) {
        reasonList.push({
            label: 'Anomaly',
            id: 'anomaly',
            key: 'reason-1'
        });
    } else {
        reasonList.push({
            label: 'Mapitaly Mission',
            id: 'mapitaly-mission',
            key: 'reason-1'
        });
    }

    const sendContactUsEmail = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() !== false) {
            console.log('Sending e-mail with data', contactUsForm)
            await axiosHandler.getInstance().post(`${process.env.REACT_APP_API_URL}/store/contact`, contactUsForm)
                .then((result) => {
                    confirmAction(result.data)
                }).catch((e) => {
                    updateModal({
                        modalTitle: null,
                        modalText: e.message,
                        confirmText: "Ok",
                        cancelText: null,
                        show: true,
                        handleHide: null,
                        handleConfirm: null
                    });
                });
        }
        setValidated(true);
    }

    const termsAndConditionsPDFlink = process.env.REACT_APP_MAPIT_TERMS_AND_CONDITIONS_PDF;
    const acceptanceText = <>* Confirm your acceptance of the {termsAndConditionsPDFlink ? <a target="_blank" href={termsAndConditionsPDFlink}>Terms and conditions</a> : null}
                                    </>
    return (
        <>
            <Form noValidate validated={validated} id="contactUsForm" className="contactUsForm" onSubmit={sendContactUsEmail}>
                <Form.Group className="mt-2">
                    <Form.Label>{isAuthenticated  ? `Username *` : `Name *`}</Form.Label>
                    <Form.Control required disabled={isAuthenticated && user} id="name" name="name" onChange={handleContactUsFormChange} value={contactUsForm.name} type="text" placeholder="" />
                </Form.Group>
                {!isAuthenticated &&
                    <Form.Group className="mt-2">
                        <Form.Label>Last Name *</Form.Label>
                        <Form.Control required id="lastname" name="lastname" onChange={handleContactUsFormChange}  value={contactUsForm.lastname} type="text" placeholder="" />
                    </Form.Group>
                }
                <Form.Group className="mt-2">
                    <Form.Label>Email address *</Form.Label>
                    <Form.Control required disabled={isAuthenticated && user} id="email" name="email" onChange={handleContactUsFormChange} value={contactUsForm.email} type="email" placeholder="" />
                </Form.Group>
                <Form.Group className="mt-2">
                    <Form.Label>Company</Form.Label>
                    <Form.Control id="company" name="company" onChange={handleContactUsFormChange} value={contactUsForm.company} type="text" placeholder="" />
                </Form.Group>

                <Form.Group className="mt-2">
                    <Form.Label>Reason *</Form.Label>
                    <Form.Select required id="reason" name="reason" onChange={handleContactUsFormChange} value={contactUsForm.reason} aria-label="Pick Reason">
                        <option value=""></option>
                        {
                            reasonList.map((reason) => <option key={reason.key} value={reason.id}>{reason.label}</option>)
                        }
                    </Form.Select>
                </Form.Group>
                <Form.Group className="mt-2">
                    <Form.Label>Description *</Form.Label>
                    <Form.Control required as="textarea" id="description" name="description" onChange={handleContactUsFormChange} value={contactUsForm.description} rows={3} />
                </Form.Group>
                <Form.Group className="mt-2">
                    <Form.Label>Attachment</Form.Label>
                    <Form.Control id="Attachment" name="Attachment" onChange={handleContactUsFormChange} value={contactUsForm.Attachment} type="file" />
                </Form.Group>
                <Form.Group className="mt-3">
                    <Form.Check type="checkbox"
                        required
                        disabled={isAuthenticated && user}
                        id="acceptance"
                        name="acceptance"
                        onChange={handleContactUsFormChange}
                        checked={contactUsForm.acceptance}
                        label={acceptanceText}
                    />
                </Form.Group>
                <Button style={{float: "right"}} className="button1 mt-3" type="submit">
                    Submit
                </Button>
            </Form>
            <MapitalyModal {...modal}></MapitalyModal>
        </>
    )
}
const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user,
})

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactUs)
